var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBalance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.167.833h-8.45v.717a.717.717 0 01-1.433 0V.833H.834v1.433h2.522L.833 8.573v.138a3.585 3.585 0 003.581 3.58 3.585 3.585 0 003.58-3.58v-.138L5.473 2.266h2.502c.216.61.7 1.093 1.31 1.31V14.87H7.135a2.15 2.15 0 00-2.148 2.148v.716H3.555v1.433h12.89v-1.433h-1.432v-.716a2.15 2.15 0 00-2.149-2.148h-2.148V3.575c.61-.216 1.094-.7 1.31-1.31h2.502l-2.523 6.308v.138a3.585 3.585 0 003.58 3.58 3.585 3.585 0 003.582-3.58v-.138l-2.523-6.307h2.523V.833zM4.414 10.86c-.934 0-1.73-.6-2.025-1.433h4.05a2.151 2.151 0 01-2.025 1.433zM6.22 7.995H2.608l1.806-4.517L6.22 7.995zm6.644 8.307c.395 0 .717.322.717.716v.716H6.419v-.716c0-.395.321-.716.716-.716h5.73zm2.722-5.442c-.934 0-1.73-.6-2.025-1.433h4.05a2.151 2.151 0 01-2.025 1.433zm1.806-2.865H13.78l1.807-4.517 1.806 4.517z",
    fill: "url(#balance_svg__paint0_linear_6376_98402)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "balance_svg__paint0_linear_6376_98402",
    x1: 10,
    y1: 0.834,
    x2: 10,
    y2: 19.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1393BC"
  })))));
}

export default __webpack_public_path__ + "./fonts/balance.f668b5a07917e73c7ccb3f5c938c4eff.svg";
export { SvgBalance as ReactComponent };